import MeaDetailField from "../../../../components/MeaDetailField";
import MeaDetailCard from "../../../../components/MeaDetailCard";
import MeaLink from "../../../../components/MeaLink";

const CourseDetailComponent = ({ course }) => {
  return (
    <>
      <MeaDetailCard>
        <MeaDetailField field="Nom de la matière" value={course?.name} />
        <MeaDetailField
          field="Niveau"
          value={
            <MeaLink
              to={
                "/school/" +
                course?.school_id +
                "/admin/trainings/" +
                course?.training_id +
                "/levels/" +
                course?.level?.id
              }
            >
              {course?.level?.name}
            </MeaLink>
          }
        />
        <MeaDetailField
          field="Présentation"
          value={course?.presentation || " "}
        />
      </MeaDetailCard>
    </>
  );
};

export default CourseDetailComponent;
